import * as React from "react";
import styled, { css, keyframes } from "../../styled";
import { IconArrowLeft, IconClose } from "./modal-icons";
const Header = styled("div") `
	display: flex;
	align-items: flex-start;
	gap: 10px;
	padding: 12px 16px;
	border-bottom: 1px solid #dfdfdf;
`;
const IconButton = styled("button") `
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
	width: 36px;
	height: 36px;
	padding: 0;
	border: none;
	border-radius: 8px;
	background: transparent;
	color: #717680;
	cursor: pointer;
	&:hover {
		background: rgba(10, 13, 18, 0.05);
	}
`;
const Content = styled("div") `
	flex: 1 1 0;
	min-width: 0;
	display: flex;
	flex-direction: column;
	gap: 8px;
	padding-top: 2px;
`;
const Title = styled("div") `
	font-size: 14px;
	font-weight: 500;
	line-height: 1.3;
	color: ${({ theme }) => theme.box.text};
	word-break: break-word;
`;
const Subtitle = styled("div") `
	margin-top: 2px;
	font-size: 12px;
	font-weight: 400;
	opacity: 0.8;
	word-break: break-all;
`;
const flashBadge = keyframes `
	0% { opacity: 1; }
	50% { opacity: 0.45; }
	100% { opacity: 1; }
`;
/** Red pill used for "Order No. X", "Pickup Time: ..." etc. */
export const ModalBadge = styled("span") `
	display: inline-flex;
	align-items: center;
	align-self: flex-start;
	padding: 2px 8px;
	border-radius: 6px;
	border: 1px solid #fecdca;
	background: #fef3f2;
	color: #b42318;
	font-size: 14px;
	font-weight: 500;
	line-height: 20px;
	white-space: nowrap;
	${({ flash }) => flash ? css `animation: ${flashBadge} 1.5s infinite;` : ""}
`;
export const OrderModalHeader = (props) => {
    const { title, subtitle, badge, badgeFlash, badgeKey, extra, onClose, onBack } = props;
    return (React.createElement(Header, null,
        onBack && (React.createElement(IconButton, { type: "button", onClick: onBack, "aria-label": "Back" },
            React.createElement(IconArrowLeft, null))),
        React.createElement(Content, null,
            React.createElement("div", null,
                React.createElement(Title, null, title),
                subtitle && React.createElement(Subtitle, null, subtitle)),
            badge && React.createElement(ModalBadge, { key: badgeKey, flash: badgeFlash }, badge),
            extra),
        onClose && (React.createElement(IconButton, { type: "button", onClick: onClose, "aria-label": "Close" },
            React.createElement(IconClose, null)))));
};
//# sourceMappingURL=modal-header.js.map